export default __webpack_public_path__ + "static/6_27-1--8aa4a4ff1fc2fda70fbf223708ffa59b.png";